<div class="share-member-invite">
    <sync-dialog
      [config]="{
        title: 'Add users',
        subTitle: name,
        isClosable: true,
        closeIcon:'arrow-left',
        onCloseIcon: onBack,
        cancelButton: 'Close',
        onCancelClick: closeDialog,
      actionButton: 'Send invitations',
      onActionClick: onSend,
      isButtonLoading: spinner,
      isActionButtonDisabled: (!sharememberInvite?.queue?.length && !sharememberInvite?.roleQueue?.length),
      }"
      [open]="showDialog"
      [isFullScreen]="isSmallScreen"
    >
    <div class="member-invite-container">
      <app-error *ngIf="errcode" [errcode]="errcode"></app-error>
        <span class="body-2"
        >Users who accept your invitation will have this folder added to their
        Sync account and synchronized to their computers when the desktop
        application is installed.
        <a
          class="body-2-link"
          href="https://help.sync.com/hc/en-us/articles/38492019181459-How-to-use-team-shared-folders#manageshare"
          target="_blank"
          >Learn more</a
        ></span
      >
      <div class="email-container">
        <app-share-member-add
        [sharememberInvite]="sharememberInvite"
        [shareData]="shareData"
        [closeDialog]="closeDialog"
        ></app-share-member-add>
      </div>
    </div>
    </sync-dialog>
  </div>
  